import ReporteBase from "./ReportePage.js";

const ReporteNotaVenta = () => {
    return (
        <ReporteBase
            titulo="Reporte de Nota de ventas"
            variant="NOTAVENTA"
        />
    );
};

export default ReporteNotaVenta;